import { defineMessages } from "react-intl";

export const messages = defineMessages({
  integrations: {
    id: "MaTR88",
    defaultMessage: "Integrations",
    description: "header",
  },
  forkOnGithub: {
    id: "zmnGkp",
    defaultMessage: "Fork on GitHub",
    description: "button",
  },
  releaseComingSoon: {
    id: "gXvoFf",
    defaultMessage: "{releaseDate}",
    description: "information",
  },
  installationCloudOnly: {
    defaultMessage: "Use Verda Cloud to access Verda Apps",
    description: "description",
    id: "ZKjCXa",
  },
});
